import { PermisoesHelper } from "../../helpers";
import { ContasPagarService } from "../../services";
import { ImportarTitulos } from "./components";
import { TituloPagar } from "./entities";
import {
  buscarMeiosPagamento,
  buscarPessoas,
  colunasGrid,
  formatarData,
  lerPlanilha,
} from "./importar-titulos";

const contasPagarService = new ContasPagarService();

const colunas = colunasGrid("Fornecedor", [
  {
    field: "dataCompetencia",
    headerName: "Data de Competência",
    width: 170,
    valueFormatter: formatarData,
  },
]);

const ImportarContasPagarView = () => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("contas-pagar-cadastrar");

  async function montarTitulos(arquivo) {
    const linhas = await lerPlanilha(
      arquivo,
      "Fornecedor (Id do Fornecedor do Evolution)",
    );
    const [pessoas, meiosPagamento] = await Promise.all([
      buscarPessoas(linhas),
      buscarMeiosPagamento(),
    ]);
    const cadastros = { pessoas, meiosPagamento };
    return linhas.map((linha) => new TituloPagar(linha, cadastros));
  }

  return (
    <ImportarTitulos
      tituloTela="Importação de Contas a Pagar"
      colunas={colunas}
      montarTitulos={montarTitulos}
      service={contasPagarService}
      rotaListagem="/financeiro/contas-pagar"
    />
  );
};

export default ImportarContasPagarView;
